import { useState, useEffect } from 'react'
import { useTranslation } from "react-i18next";

import './css/Filter.css'
export default function Filter({ children, Open, setOpen }) {

    const { t } = useTranslation();
    
    function closeFilter() {
        setOpen(false);
    }
    

    return (
        <>
            <div onClick={closeFilter} className={`filterPagesBox ${Open ? "open" : "closed"}`}></div>
            <div className={`filterBodyBox ${Open ? "open" : "closed"}`}>
                <h1>{t("filter")}</h1>
                {children}
            </div>
        </>
    )
}
